import { WeldingPattern } from '@interfaces/welding-patterns';
import { getCall } from '@services/rest-service';

// Retrieves all the welding patterns from cosmos
export const getWeldingPatterns = (): Promise<WeldingPattern[]> => {
  return getCall<WeldingPattern[]>('welding-patterns');
};